import { render, staticRenderFns } from "./RicOtherLogs.vue?vue&type=template&id=7b107596"
import script from "./RicOtherLogs.vue?vue&type=script&lang=js"
export * from "./RicOtherLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports